export default function StatCard({ label, value, icon: Icon, color = "green", testid }) {
  const colors = {
    green: "bg-emerald-50 text-[#009E60] dark:bg-emerald-900/20",
    blue: "bg-blue-50 text-[#3A75C4] dark:bg-blue-900/20",
    yellow: "bg-amber-50 text-amber-600 dark:bg-amber-900/20",
    slate: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300",
  };
  const bars = {
    green: "bg-[#009E60]",
    blue: "bg-[#3A75C4]",
    yellow: "bg-[#FCD116]",
    slate: "bg-slate-400 dark:bg-slate-600",
  };
  return (
    <div className="stat-card relative overflow-hidden" data-testid={testid}>
      <span className={`absolute top-0 left-0 right-0 h-1.5 ${bars[color]}`} />
      <div className="flex items-center justify-between pt-1">
        <div className="min-w-0">
          <p className="text-[10px] sm:text-xs font-semibold uppercase tracking-wider text-muted-foreground truncate">{label}</p>
          <p className="mt-1 text-xl sm:text-2xl font-heading font-bold" data-testid={`${testid}-value`}>
            {typeof value === "number" ? value.toLocaleString("fr-FR") : value}
          </p>
        </div>
        {Icon && (
          <div className={`rounded-xl p-2.5 shrink-0 ${colors[color]}`}>
            <Icon className="h-5 w-5" />
          </div>
        )}
      </div>
    </div>
  );
}
